import CommentButton from './CommentButton';

export default CommentButton;
